module.exports = __webpack_public_path__ + "img/bos.35f59c8d.png";